import React, { useEffect, useState, useRef, useMemo, useLayoutEffect } from "react"
import './index.scss'
import './reset.scss'
import useQuery from "@/hooks/useQuery"
import QRCode from 'qrcodejs2'
// import MessageBox from "@/components/message-box"
import { isInViewPort } from "@/utils/common"

import CheckedIcon from '../../media-vip/assets/checked.png'
import UncheckedIcon from '../../media-vip/assets/unchecked.png'
import CheckedIconYellow from '../../media-vip/assets/checked-yellow.png'
import UncheckedIconYellow from '../../media-vip/assets/unchecked-yellow.png'
import WechatpayIcon from '../../media-vip/assets/wechatpay.png'
import AlipayIcon from '../../media-vip/assets/alipay.png'
import ErrorIcon from '../../media-vip/assets/error.png'
import ErrorDarkIcon from '../../media-vip/assets/error-dark.png'
import WechatpayDarkIcon from '../../media-vip/assets/wechatpay-dark.png'
import AlipayDarkIcon from '../../media-vip/assets/alipay-dark.png'
import RefreshIcon from '../../media-vip/assets/refresh.png'

import {
  getXimalayaProductList,
  getXimalayaSignQrCode,
  getXimalayaSignStatus,
  getXimalayaPayQrCode,
  getXimalayaPayStatus,
  getKugouProductList,
  getKugouSignQrCode,
  getKugouSignStatus,
  getKugouPayQrCode,
  getKugouPayStatus,
  getCarType
} from '@/api/media-vip'

const mockData = {
	"list": [
		{
			"list": [
				{
					"autoRenew": true,
					"autoRenewTag": "连续包月20，下个月自动续费",
					"discountPrice": 19,
					"itemId": 230504004,
					"name": "12个月",
					"originPrice": 99,
					"title": "喜马拉雅会员",
					"topTag": "新用户专享"
				},
        {
					"autoRenew": true,
					"autoRenewTag": "连续包月18，下个月自动续费",
					"discountPrice": 59,
					"itemId": 230504005,
					"name": "6个月",
					"originPrice": 1999,
					"title": "喜马拉雅会员",
					"topTag": "限时特惠"
				}
			],
			"vipType": "超级会员"
		},
    {
			"list": [
				{
					"autoRenew": true,
					"autoRenewTag": "连续包月20，下个月自动续费",
					"discountPrice": 49,
					"itemId": 230504100,
					"name": "24个月",
					"originPrice": 99,
					"title": "喜马拉雅会员",
					"topTag": "超级会员专享1"
				},
        {
					"autoRenew": false,
					"autoRenewTag": "",
					"discountPrice": 59,
					"itemId": 230504101,
					"name": "6个月",
					"originPrice": 1999,
					"title": "喜马拉雅会员",
					"topTag": ""
				}
			],
			"vipType": "车载会员"
		}
	],
	"payModeList": [1,2]
}

// 音源映射：1-Q音 2-网易云音乐 4-酷狗 5-喜马拉雅
const mediaConfig = {
  4: {
    getProductList: getKugouProductList,
    getSignQrCode: getKugouSignQrCode,
    getSignStatus: getKugouSignStatus,
    getPayQrCode: getKugouPayQrCode,
    getPayStatus: getKugouPayStatus,
    agreement: {
      service: 'https://activity.kugou.com/privacy/v-11fc07cb/index.html',
      renewal: 'https://activity.kugou.com/voo/v-4a1f3303/index.html'
    }
  },
  5: {
    getProductList: getXimalayaProductList,
    getSignQrCode: getXimalayaSignQrCode,
    getSignStatus: getXimalayaSignStatus,
    getPayQrCode: getXimalayaPayQrCode,
    getPayStatus: getXimalayaPayStatus,
    agreement: {
      service: 'https://m.ximalaya.com/gatekeeper/member-agreement-html',
      renewal: 'https://pages.ximalaya.com/mkt/act/8e7818e03c5f7509'
    }
  }
}

const Error = ({
  msg = '加载失败，请稍后重试',
  theme = 'day'
}) => {
  const errorIcon = theme === 'night' ? ErrorDarkIcon : ErrorIcon
  return (
    <div className={`errorWrap ${theme === 'night' ? 'night' : ''}`}>
      <img src={errorIcon} alt="" className={'errorImg'} />
      <div className={'msg'}>{msg}</div>
    </div>
  )
}

const App = () => {
  // 音源映射：1-Q音 2-网易云音乐 4-酷狗 5-喜马拉雅
  const mediaType = useQuery().get('mediaType') || ''
  // 白天黑夜模式：day-白天 night-黑夜
  const defaultTheme = useQuery().get('theme') || 'day'
  // E29 主题色修改为黄色
  const [isYellowPrimaryColor, setIsYellowPrimaryColor] = useState(false)

  const [loadingError, setLoadingError] = useState(false)
  const [theme, setTheme] = useState(defaultTheme)
  const networkErrorTimer = useRef<any>(null)

  const [selectedVipType, setSelectedVipType] = useState<any>(null)
  const [selectedSkuId, setSelectedSkuId] = useState<any>(null)
  const [vipSkuData, setVipSkuData] = useState<any>(null)
  const [renewalTip, setRenewalTip] = useState('')
  const [checkedRenewalTip, setCheckedRenewalTip] = useState(true)
  const [finalPrice, setFinalPrice] = useState('')
  const [showQrCodeCover, setShowQrCodeCover] = useState(false)
  const [isQrCodeLoading, setIsQrCodeLoading] = useState(false)
  const [qrCodeInfo, setQrCodeInfo] = useState<any>(null)

  const currentSkuRef = useRef<any>(null)
  const qrCodeRef = useRef(null)
  const statusLoopTimer = useRef<any>(null)
  const qrCodeInvalidTimer = useRef<any>(null)
  const userStayInfo = useRef({
    start_time: '',
    end_time: ''
  })
  const jumpDebounceTimer = useRef<any>(null)
  const skuScrollDebounceTimer = useRef<any>(null)
  const qrCodeUrl = useRef('')

  const currentSkuList = useMemo(() => {
    if (vipSkuData?.list?.length > 0) {
      return vipSkuData?.list?.find((item: any) => item.vipType === selectedVipType)?.list || []
    }
    return []
  }, [vipSkuData, selectedVipType])

  // payModeList: String[] 1-支付宝 2-微信
  const payType = useMemo(() => {
    if (Array.isArray(vipSkuData?.payModeList) && vipSkuData?.payModeList?.length > 0) {
      if (vipSkuData.payModeList.includes(1) && vipSkuData.payModeList.includes(2)) {
        return 'both'
      } else if (vipSkuData?.payModeList.includes(1)) {
        return 'ali'
      } else {
        return 'wx'
      }
    } else {
      return 'wx'
    }
  }, [vipSkuData])

  useLayoutEffect(() => {
    // setHtmlFontSize('useLayoutEffect')
  }, [])

  useEffect(() => {
    getVipSkuList()

    registerWindowListener()

    userStayInfo.current.start_time = new Date().toLocaleString()

    // 提供给大屏调用切换白天黑夜
    console.log('currentUrl: ', window.location.href)
    console.log('theme init: ', defaultTheme)
    window['setMediaVipTheme'] = (theme: any) => {
      console.log('screen call setMediaVipTheme: ', theme)
      setTheme(theme)
    }

    judgeCarType()

    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    clearStatusLoop()
    clearQrCodeInvalidTimer()

    userStayInfo.current.end_time = new Date().toLocaleString()
    reportData('P20014', 'B006', {
      source: mediaType,
      ...userStayInfo.current
    })
  }

  /**
   * 获取车型 并设置黄色主题色
   */
  const judgeCarType = () => {
    const carType = getCarType()
    console.log('carType: ', carType)
    if (carType === 'E29') {
      setIsYellowPrimaryColor(true)
    }
  }

  /**
   * F57 8寸屏样式适配需求rem方案处理
   */
  const setHtmlFontSize = (lifeCycle: string) => {
    console.log('window.innerWidth', window.innerWidth)
    console.log('document.documentElement.clientWidth', document.documentElement.clientWidth)
    if (window.innerWidth > 800) {
      document.documentElement.style.fontSize = '1px'
    } else {
      document.documentElement.style.fontSize = `${window.innerWidth / 1280}px`
    }

    console.log(`${lifeCycle} setHtmlFontSize: `, document.documentElement.style.fontSize)
  }

  const registerWindowListener = () => {
    window.addEventListener('resize', (e) => {
      // 窗口大小变化时，若当前选中的sku不在可视窗口内，滑动到可视区域（用户切1/3屏时兜底处理）
      if (currentSkuRef.current && !isInViewPort(currentSkuRef.current)) {
        clearTimeout(skuScrollDebounceTimer.current)
        skuScrollDebounceTimer.current = setTimeout(() => {
          currentSkuRef.current.scrollIntoView()
        }, 300)
      }
    })
  }

  const openWebview = (url: string, zoom = 100) => {
    console.log('openWebview: ', url, zoom)
    try {
      // url: string, zoom: number(缩放倍数 必填 100表示1:1 以此类推)
      if (window.xpVipBuyBridge) {
        window.xpVipBuyBridge?.showWebDialog(url, zoom)
      } else {
        window.open(url, '_blank')
      }
    } catch (error) {
      // TODO
    }
  }

  // 通过大屏上报埋点
  const reportData = (pageId: string, buttonId: string, params = {}) => {
    try {
      const jsonParams = JSON.stringify(params)
      window.xpVipBuyBridge?.reportClick(pageId, buttonId, jsonParams)

      console.log('reportData: ', pageId, buttonId, jsonParams)
    } catch (error) {
      // TODO
    }
  }

  const getVipSkuList = () => {
    try {
      const callback = (res: any) => {
        console.log('getVipSkuList res: ', res)
        if (res.code === 200) {
          setVipSkuData(res?.data)
          handleClickVipType(res?.data?.list?.[0], false)
        } else {
          setLoadingError(true)
        }
      }
      mediaConfig[mediaType].getProductList({}, callback)
    } catch (error) {
      setLoadingError(true)
      console.log('getVipSkuList error: ', error)
    }
    // setVipSkuData(mockData)
  }

  const handleClickVipType = (item: any, isUserClick = true) => {
    setSelectedVipType(item.vipType)
    handleClickSku(item?.list?.[0], isUserClick)

    if (isUserClick) {
      reportData('P20014', 'B007', { source: mediaType, type: item.vipType })
    }
  }

  const handleClickSku = (item: any, isUserClick = true) => {
    setSelectedSkuId(item.itemId)
    setFinalPrice(item.discountPrice)
    setRenewalTip(item?.autoRenew ? item.autoRenewTag : '')
    setCheckedRenewalTip(true)
    
    clearQrCodeInvalidTimer()

    getQrCode(item, isUserClick)

    if (isUserClick) {
      reportData('P20014', 'B008', { source: mediaType, name: `${item.title}-${item.name}` })
    }
  }

  const getQrCode = (item, isUserClick = false) => {
    try {
      qrCodeRef.current && (qrCodeRef.current = null) // 切换sku或者点击刷新获取二维码时，先清除之前的二维码实例
      setIsQrCodeLoading(true)
      setShowQrCodeCover(true)
      const {
        getSignQrCode,
        getPayQrCode,
        getSignStatus,
        getPayStatus
      } = mediaConfig[mediaType]
      const getQrCodeRequest = item.autoRenew ? getSignQrCode : getPayQrCode
      const getStatusRequest = item.autoRenew ? getSignStatus : getPayStatus

      // 切换sku或者点击刷新获取二维码时，若当前网络异常，直接遮罩不请求
      // 在车机上监听网络状态事件不生效，兜底用定时器处理
      clearTimeout(networkErrorTimer.current)
      if (isUserClick) {
        networkErrorTimer.current = setTimeout(() => {
          setIsQrCodeLoading(false)
          setShowQrCodeCover(true)
        }, 1500)
      }

      const callback = (res: any) => {
        clearTimeout(networkErrorTimer.current)
        // 先将qrCodeUrl设置为空
        qrCodeUrl.current = ''
        if (res.code === 200) {
          setIsQrCodeLoading(false)
          setShowQrCodeCover(false)
          setQrCodeInfo(res?.data)
          if (!res?.data?.qrCodeImgUrl && res?.data?.qrCodeUrl) {
            qrCodeUrl.current = res?.data?.qrCodeUrl
            remakeQrCode()
          }
          // 二维码有效时长effectiveTime，单位分钟，失效后遮罩，让用户点击刷新
          if (res?.data?.effectiveTime) {
            const effectiveTime = res?.data?.effectiveTime * 60 * 1000
            qrCodeInvalidTimer.current = setTimeout(() => {
              setIsQrCodeLoading(false)
              setShowQrCodeCover(true)
            }, effectiveTime)
          }
  
          loopStatus(getStatusRequest, item.autoRenew, res?.data?.orderNum)
        }
      }
      
      getQrCodeRequest({ itemId: item.itemId }, callback)
    } catch (error) {
      console.log('getQrCode error: ', error)
    }
  }

  const clearQrCodeInvalidTimer = () => {
    if (qrCodeInvalidTimer.current) {
      clearTimeout(qrCodeInvalidTimer.current)
      qrCodeInvalidTimer.current = null
    }
  }

  const reloadQrCode = () => {
    setIsQrCodeLoading(true)
    setShowQrCodeCover(true)
    getQrCode(currentSkuList.find((item: any) => item.itemId === selectedSkuId), true)
  }
  
  const clearStatusLoop = () => {
    if (statusLoopTimer.current) {
      clearInterval(statusLoopTimer.current)
      statusLoopTimer.current = null
    }
  }

  const loopStatus = (getStatus: Function, isAutoRenew: boolean, orderId: string) => {
    clearStatusLoop()
    
    const reqData = isAutoRenew ? {} : { orderId }

    const callback = (res: any) => {
      if (res.code === 200) {
        // 两个状态响应的状态码一致：retCode
        // 签约状态码 0-未签约、1-已签约
        // 订单状态码 1-待支付、2-已支付、3-已发货、4-订单取消 5-异常
        if (isAutoRenew) {
          if (res.data?.retCode === 1) {
            clearStatusLoop()
            // 成功后由大屏主动关闭webview并toast提示成功，这里H5不处理
            // MessageBox.toast('会员开通成功')
          }
        } else {
          if ([2,3].includes(res.data?.retCode)) {
            clearStatusLoop()
            // 成功后由大屏主动关闭webview并toast提示成功，这里H5不处理
            // MessageBox.toast('会员开通成功')
          } else if ([4,5].includes(res.data?.retCode)) {
            clearStatusLoop()
          }
        }
      } else {
        clearStatusLoop()
        console.log('getStatus error: ', res)
      }
    }

    statusLoopTimer.current = setInterval(() => {
      try {
        getStatus(reqData, callback)
      } catch (error) {
        clearStatusLoop()
        console.log('loopStatus error: ', error)
      }
    }, 5000)
  }

  const goToAgreement = (type: string) => {
    const targetUrl = mediaConfig?.[mediaType]?.agreement?.[type]
    if (!targetUrl) return
    let zoom = 200
    if (mediaType === '4') {
      type === 'service' && (zoom = 200)
      type === 'renewal' && (zoom = 130)
    } else if (mediaType === '5') {
      zoom = 200
    }
    clearTimeout(jumpDebounceTimer.current)
    jumpDebounceTimer.current = setTimeout(() => {
      // openWebview(targetUrl, 100)
      openWebview(targetUrl, zoom)
    }, 1000)
  }

  const createQrCode = (url: string) => {
    qrCodeRef.current = null
    const qrCodeContainer = document.getElementById('qrcode-container') as any
    qrCodeContainer.innerHTML = ''
    let width = window.innerWidth < 800 ? 130 : 224
    let height = window.innerWidth < 800 ? 130 : 224
    qrCodeRef.current = new QRCode(qrCodeContainer, {
      text: url,
      width: width,
      height: height,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
  }

  const handleClickRenewalTip = () => {
    setCheckedRenewalTip(!checkedRenewalTip)

    reportData('P20014', 'B005', { source: mediaType })
  }

  const remakeQrCode = () => {
    if (qrCodeUrl.current) {
      qrCodeRef.current = null
      const qrCodeContainer = document.getElementById('qrcode-container') as any
      qrCodeContainer.innerHTML = ''
      let width = window.innerWidth < 800 ? 130 : 224
      let height = window.innerWidth < 800 ? 130 : 224
      qrCodeRef.current = new QRCode(qrCodeContainer, {
        text: qrCodeUrl.current,
        width: width,
        height: height,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    }
  }
  // 监听屏幕尺寸变化 尺寸变化重新生成二维码
  useEffect(() => {
    // component is mounted and window is available
    window.addEventListener('resize', remakeQrCode)
    // unsubscribe from the event on component unmount
    return () => window.removeEventListener('resize', remakeQrCode)
  }, [])

  if (loadingError) {
    return <Error theme={theme} />
  }

  const wxPayIcon = theme === 'night' ? WechatpayDarkIcon : WechatpayIcon
  const aliPayIcon = theme === 'night' ? AlipayDarkIcon : AlipayIcon

  return (
    <div className={`mediaVipWrap ${theme === 'night' ? 'night' : ''}`}>
      <div className={'tabScrollView'}>
        <div className={'tabBar'}>
          {
            vipSkuData?.list.length > 0 && (
              vipSkuData?.list.length > 1 ? (
                vipSkuData?.list.map((item: any, index: number) => (
                  <div className={'tab'} key={index}>
                    <div
                      className={`${'tabName'} ${selectedVipType === item.vipType ? 'selected' : ''}`}
                      onClick={() => handleClickVipType(item)}
                    >{item.vipType}</div>
                    { selectedVipType === item.vipType &&
                      <div
                        className={`underline ${isYellowPrimaryColor ? 'primaryYellow' : ''}`}>
                      </div>
                      }
                  </div>
                ))
              ) : (
                <div className={'tab'}>
                  <div className={`${'tabName'} ${'selected'}`}>{vipSkuData?.list?.[0].vipType}</div>
                </div>
              )
            )
          }
        </div>
      </div>
      <div className={'skuRow'}>
        <div className='skuRowWrap'>
          {
            currentSkuList.length > 0 && currentSkuList.map((item: any, index: number) => (
              <div
                className={`skuCard ${selectedSkuId === item.itemId ?
                  (item.topTag ? 'gold-selected' : `${isYellowPrimaryColor ? 'primaryYellow' : 'selected'}`) : ''}`}
                key={index}
                onClick={() => handleClickSku(item)}
                ref={selectedSkuId === item.itemId ? currentSkuRef : null}
              >
                {
                  !!item?.topTag && (
                    <div className={`goldCover ${selectedSkuId === item.itemId ? 'selected' : ''}`}></div>
                  )
                }
                { item.topTag && <div className={`${'tag'} ${'gold'}`}>{item.topTag}</div> }
                <div className='mainInfo'>
                  <div className={'name'}>{item.name}</div>
                  <div className={'priceInfo'}>
                    <div className={'unit'}>¥</div>
                    <div className={'price'}>{item.discountPrice}</div>
                  </div>
                  { item?.originPrice ? <div className={`${'originPrice'} ${item.topTag ? 'gold' : ''}`}>¥{item?.originPrice}</div> : null }
                </div>
              </div>
            ))
          }
        </div>
      </div>
      {
        !!renewalTip && (
          <div className={'renewalTip'} onClick={handleClickRenewalTip}>
            {
              checkedRenewalTip ? <img src={isYellowPrimaryColor ? CheckedIconYellow : CheckedIcon} alt='' className={'icon'} /> :
              <img src={isYellowPrimaryColor? UncheckedIconYellow : UncheckedIcon} alt='' className={'icon'} />
            }
            <div className={'text'}>{renewalTip}</div>
          </div>
        )
      }
      <div className={'payCard'}>
        <div className={'qrCodeWrap'}>
          {
            qrCodeInfo?.qrCodeImgUrl ?
            <img className={`qrCode ${isQrCodeLoading ? 'loading' : ''}`} alt='' src={qrCodeInfo?.qrCodeImgUrl} /> :
            <div className={`qrCode ${isQrCodeLoading ? 'loading' : ''}`} id='qrcode-container'></div>
          }
          {
            !checkedRenewalTip && (
              <div className={'greyCover'} onClick={() => setCheckedRenewalTip(true)}>
                点击同意<br />开通协议
              </div>
            )
          }
          {
            showQrCodeCover && (
              <div className={'greyCover'} onClick={reloadQrCode}>
                <img alt="" className={`qrCodeLoadingIcon ${isQrCodeLoading ? 'spin' : ''}`} src={RefreshIcon} />
              </div>
            )
          }
        </div>
        <div className={'payInfo'}>
          <div className={'priceInfo'}>
            <div className={'unit'}>¥</div>
            <div className={'price'}>{finalPrice}</div>
          </div>
          <div className={'payType'}>
            {
              payType === 'both' && (
                <>
                  <img className={'wxImg'} alt='' src={wxPayIcon} />
                  <span className={'devide'}>/</span>
                  <img className={'aliImg'} alt='' src={aliPayIcon} />
                </>
              )
            }
            { payType === 'wx' && <img className={'wxImg'} alt='' src={wxPayIcon} /> }
            { payType === 'ali' && <img className={'aliImg'} alt='' src={aliPayIcon} /> }
          </div>
          <div className={'agree'}>
            开通即代表阅读并同意
            <span className={`link ${isYellowPrimaryColor ? 'primaryYellow': ''}`} onClick={() => goToAgreement('service')}>《会员服务协议》</span>
            与
            <span className={`link ${isYellowPrimaryColor ? 'primaryYellow': ''}`}onClick={() => goToAgreement('renewal')}>《自动续费协议》</span>
          </div>
        </div>
      </div>
      <div className='bottom-block'></div>
    </div>
  )
}

export default App
